export class RegistrationFields {
    username: string = "";
    email: string = "";
    password: string = "";
    confirmPassword: string = "";
    fullName: string = "";
    street: string = "";
    number: number;
    city: string = "";
    country: string = "";
    phone: string = "";
    fax: string = "";
    mobile: string = "";
}


// WEBPACK FOOTER //
// ./app/insa-models/registrationFields.model.ts